// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"c8203a79","453":"8056479a","732":"25be94f9","762":"4fe7e32b","977":"228a8bab"}[chunkId] + ".chunk.js";
};